import React, {useEffect, useState} from "react"
import QueueCard from "./QueueCard"
import {supabase} from './SupabaseClient'

const QueueList:React.FC<any> = (props) => {
  const [queue_data, set_queue_list] = useState<any[]>([])

  const handleSubscribeQueue = (payload:any) => {
    console.log("task update")
    console.log(payload)
    //TODO: 更新されたデータのみstateを更新する
    handleGetQueue()
  }

  useEffect(()=>{
    handleGetQueue()
    const channel = supabase
    .channel('queue_update')
    .on('postgres_changes', { event: '*', schema: 'public', table: 'task' }, handleSubscribeQueue)
    .subscribe()
    return () => {
      supabase.removeChannel(channel)
    }
  },[])

  const handleGetQueue = async () => {
    const {data, error} = await supabase.from('task').select(`*, print_data(id, name), printer:use_printer_id(id, printer_name)`).order('enqueue_at', { ascending: false })
    console.log(data)
    if(data !== null){
      set_queue_list(data)
    }
  }

  const handleCancelQueue = async (d:any) =>{
    if (window.confirm("対象のキューをキャンセルしますか？")){
      const { data, error } = await supabase.from('task')
              .update({ status: 3 })
              .eq('id', d.id)
              .select()
      await handleGetQueue()
    }
  }


  return(
    <div className="bg-white py-6 sm:py-8 lg:py-12">
      <div className="px-4 md:px-8 mx-auto">
        <h1 className="text-gray-800 text-2xl lg:text-3xl font-bold my-1">キューリスト</h1>
        <div className="flex flex-col">
          {
            queue_data.map((d, )=> {
              return (
                <QueueCard key={d.id}
                  queue_data={d}
                  handle_cancel={handleCancelQueue}
                ></QueueCard>
              )
            })
          }
        </div>
      </div>
    </div>
  )
}

export default QueueList